module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/assets/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.woff
// module chunks = styles